import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import DashboardCard from '../DashboardCard'
import {
	GetOverallAnalyticsResponse,
	GetOnlineActiveUserResponse,
} from '@/modules/dashboard/type'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'

interface DashboardListingProps {
	data?: GetOverallAnalyticsResponse
	isLoading?: boolean
	onlineUsersData?: GetOnlineActiveUserResponse
	isLoadingOnlineUsers?: boolean
}

export default function DashboardListing({
	data,
	isLoading,
	onlineUsersData,
	isLoadingOnlineUsers,
}: DashboardListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex justify-between">
				<Heading title={`สรุปภาพรวม`} description="สรุปภาพรวม" />

				<div className="flex flex-col items-end gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator />
			<DashboardCard
				data={data}
				isLoading={isLoading}
				onlineUsersData={onlineUsersData}
				isLoadingOnlineUsers={isLoadingOnlineUsers}
			/>
		</div>
	)
}
